
import { Component, Vue } from 'vue-property-decorator';
import { ThemeName } from '~/store/types';
import BenefitsList from '~/components/Nodes/BenefitsList.vue';
import NodesHeroVideo from '~/components/Nodes/NodesHeroVideo.vue';
import PageBottomCtas from '~/components/Nodes/PageBottomCtas.vue';
import RewardsSteps from '~/components/Nodes/RewardsSteps.vue';
import StatsList from '~/components/Nodes/StatsList.vue';
import PopcornExplainer from '~/components/Nodes/PopcornExplainer.vue';
import LandingPromoCarousel from '~/components/Home/LandingPromoCarousel.vue';

@Component({
  components: {
    BenefitsList,
    NodesHeroVideo,
    PageBottomCtas,
    RewardsSteps,
    StatsList,
    PopcornExplainer,
    LandingPromoCarousel,
  },
  meta: {
    theme: ThemeName.DARK,
  },
})
export default class NodeInfo extends Vue {
  goTo(route: string) {
    this.$router.push(route);
  }
}
